export const objectToQueryString = (obj: Record<string, string | number | boolean>): string => {
    return Object.keys(obj)
        .filter((key) => obj[key] !== undefined)
        .map((key) => encodeURIComponent(key) + "=" + encodeURIComponent(obj[key]))
        .join("&")
}  